import type { IOrganizationIntegrationMailChimp } from './OrganizationIntegrationMailChimp.interface';

export default class OrganizationIntegrationMailChimp
  implements IOrganizationIntegrationMailChimp {
  token: string;
  metaData: string;
  autoSyncListId: string;
  autoSyncList: string;
  autoSync: boolean;
  enabled: boolean;

  hasAuthentication() {
    return this.token;
  }

  isEnabledAutoSync() {
    return this.enabled() && this.autoSync && this.autoSyncList && this.autoSyncListId;
  }

  isEnabled() {
    return this.enabled && this.hasAuthentication();
  }

  static build = (data: IOrganizationIntegrationMailChimp) =>
    new OrganizationIntegrationMailChimp(data);
  static blank = () => new OrganizationIntegrationMailChimp();

  /**
   * Constructor
   * @param {IOrganizationIntegrationMailChimp} data
   */
  constructor(data?: IOrganizationIntegrationMailChimp) {
    this.token = data?.token || undefined;
    this.metaData = data?.metaData || undefined;
    this.autoSyncListId = data?.autoSyncListId || undefined;
    this.autoSyncList = data?.autoSyncList || undefined;
    this.autoSync = data?.autoSync === true;
    this.enabled = data?.enabled === true;
  }
}
